'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _ButtonBase = require('../internal/ButtonBase');

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _FullScreen = require('../internal/FullScreen');

var _FullScreen2 = _interopRequireDefault(_FullScreen);

var _contains = require('dom-helpers/query/contains');

var _contains2 = _interopRequireDefault(_contains);

var _activeElement = require('dom-helpers/activeElement');

var _activeElement2 = _interopRequireDefault(_activeElement);

var _ownerDocument = require('dom-helpers/ownerDocument');

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DIVIDER_WIDTH = '1px';
var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItem', function (theme) {
  return {
    root: {
      alignItems: 'flex-start',
      backgroundColor: theme.palette.background.paper,
      flexFlow: 'column',
      justifyContent: 'initial',
      position: 'relative',
      textDecoration: 'none'
    },
    rootFocus: {
      borderColor: theme.palette.text.lightDivider,
      zIndex: theme.zIndex.baseIndex,
      cursor: 'initial', // Override behavior from the wrapping <ButtonBase> so
      userSelect: 'initial' // content is selectable and the cursor behaves normally
    },
    disabled: {
      opacity: 0.5
    },
    divider: {
      borderBottom: DIVIDER_WIDTH + ' solid ' + theme.palette.text.lightDivider,
      top: 0,
      height: DIVIDER_WIDTH,
      marginLeft: '-' + DIVIDER_WIDTH,
      marginRight: '-' + DIVIDER_WIDTH,
      left: theme.typography.rhythmByUnit(6.5),
      right: theme.typography.rhythmByUnit(2),
      position: 'absolute',
      '$root:first-child > div > &, $rootFocus > div > &, $rootFocus + $root > div > &, :not($root) + $root:last-child > div > &': {
        borderBottomColor: 'transparent'
      }
    },
    button: {
      transition: theme.transitions.create('background-color'),
      '&:hover': {
        textDecoration: 'none',
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    },
    childrenContainer: {
      display: 'flex',
      flex: '0 auto',
      flexFlow: 'column',
      width: '100%'
    },
    invisible: theme.mixins.invisible(),
    highlight: {
      backgroundColor: theme.palette.background.highlight
    }
  };
});

var ActivityListItem = (_temp2 = _class = function (_React$Component) {
  _inherits(ActivityListItem, _React$Component);

  function ActivityListItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ActivityListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityListItem.__proto__ || Object.getPrototypeOf(ActivityListItem)).call.apply(_ref, [this].concat(args))), _this), _this.listItem = undefined, _this.focus = function () {
      if (typeof (_this.listItem || {}).focus === 'function') {
        _this.listItem.focus(); // eslint-disable-line flowtype-errors/show-errors
      }
    }, _this.handleFocus = function (e) {
      var onFocus = _this.props.onFocus;

      if (onFocus) onFocus(e);
    }, _this.handleBlur = function (e) {
      if (_this.hasFocus(e.relatedTarget)) return; // eslint-disable-line flowtype-errors/show-errors
      var onBlur = _this.props.onBlur;

      if (onBlur) onBlur(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActivityListItem, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (this.props.autoFocus) {
          this.focus();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'hasFocus',


    // eslint-disable-next-line flowtype-errors/show-errors
    value: function () {
      function hasFocus(el) {
        var currentFocus = el || (0, _activeElement2['default'])((0, _ownerDocument2['default'])(_reactDom2['default'].findDOMNode(this))); // eslint-disable-line react/no-find-dom-node
        var node = _reactDom2['default'].findDOMNode(this.listItem); // eslint-disable-line react/no-find-dom-node
        return currentFocus && node && (0, _contains2['default'])(node, currentFocus);
      }

      return hasFocus;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _classNames,
            _this2 = this;

        var _props = this.props,
            button = _props.button,
            childrenProp = _props.children,
            classNameProp = _props.className,
            componentProp = _props.component,
            disabled = _props.disabled,
            divider = _props.divider,
            expand = _props.expand,
            highlight = _props.highlight,
            onBlur = _props.onBlur,
            onFocus = _props.onFocus,
            other = _objectWithoutProperties(_props, ['button', 'children', 'className', 'component', 'disabled', 'divider', 'expand', 'highlight', 'onBlur', 'onFocus']);

        var classes = this.context.styleManager.render(styleSheet);
        var children = _react2['default'].Children.toArray(childrenProp);

        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.button, button), _defineProperty(_classNames, classes.rootFocus, expand), _defineProperty(_classNames, classes.highlight, highlight), _classNames), classNameProp);
        var dividerClassName = (0, _classnames2['default'])(classes.divider, _defineProperty({}, classes.invisible, !divider || expand));

        var listItemProps = Object.assign({
          className: className,
          disabled: disabled,
          expand: expand,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          ref: function () {
            function ref(node) {
              return _this2.listItem = node;
            }

            return ref;
          }()
        }, other);
        var ComponentMain = componentProp;

        if (button) {
          ComponentMain = _ButtonBase2['default'];
          listItemProps.component = componentProp;
          listItemProps.keyboardFocusedClassName = classes.keyboardFocused;
        }

        return _react2['default'].createElement(
          ComponentMain,
          listItemProps,
          _react2['default'].createElement('div', { className: dividerClassName }),
          _react2['default'].createElement(
            'div',
            { className: classes.childrenContainer },
            children
          )
        );
      }

      return render;
    }()
  }]);

  return ActivityListItem;
}(_react2['default'].Component), _class.defaultProps = {
  autoFocus: false,
  button: true,
  component: _FullScreen2['default'],
  disabled: false,
  divider: true
}, _temp2);
exports['default'] = ActivityListItem;


ActivityListItem.displayName = 'ActivityListItem';

ActivityListItem.contextTypes = {
  styleManager: _propTypes2['default'].object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/ActivityListItem.js
// module id = 718
// module chunks = 32